import { pipe } from 'ramda';
import { setAction, setLabel } from '@creditas-lab/analytics-events';
import { DispatchEvent, dispatchFrontendDashboardEvent } from './commons';

const dispatchSpotlightEvent: DispatchEvent = pipe(
  setAction('spotlight'),
  dispatchFrontendDashboardEvent,
);

const dispatchSpotlightStatusDefaultEvent: DispatchEvent = pipe(
  setLabel('status | default'),
  dispatchSpotlightEvent,
);

const dispatchSpotlightStatusActiveEvent: DispatchEvent = pipe(
  setLabel('status | active'),
  dispatchSpotlightEvent,
);

const dispatchSimulateButtonClickEvent: DispatchEvent = pipe(
  setLabel('simulation'),
  dispatchSpotlightEvent,
);

const dispatchSpotlighAtWorkSimulationEvent: DispatchEvent = pipe(
  setLabel('simulation_atwork'),
  dispatchSpotlightEvent,
);

const dispatchDetailsButtonClickEvent: DispatchEvent = pipe(
  setLabel('details'),
  dispatchSpotlightEvent,
);

export {
  dispatchSpotlightStatusDefaultEvent,
  dispatchSpotlightStatusActiveEvent,
  dispatchSimulateButtonClickEvent,
  dispatchDetailsButtonClickEvent,
  dispatchSpotlighAtWorkSimulationEvent,
};
